import React from 'react';
import { Reveal } from '../../components/Reveal';

export const Footer = () => (
  <footer className="pf-section" style={{ paddingTop: 0 }}>
    <div className="pf-container">
      <div className="pf-footer">
        <Reveal as="p" distance={0} className="pf-footer-copy">
          © {new Date().getFullYear()} Jam Ardines. All rights reserved.
        </Reveal>
      </div>
    </div>
  </footer>
);
